import { optional, array, required } from 'AppReact/schema';

export default {
  checklist_id: optional('integer'),
  title: required('string'),
  titleError: optional('string'),
  description: required('string'),
  descriptionError: optional('string'),
  attachmentsIds: array('string'),
  createError: optional('string'),
  isVisible: required('boolean'),
  dueDate: optional('jsDate')
}

export const defaultNewInspectionTaskModal = {
  title: '',
  titleError: '',
  description: '',
  descriptionError: '',
  attachmentsIds: [],
  createError: null,
  checklist_id: null,
  isVisible: false,
  dueDate: null,
}